import { render } from "./SettingsTemplate.vue?vue&type=template&id=2a6d9ffc&scoped=true"
import script from "./SettingsTemplate.vue?vue&type=script&lang=js"
export * from "./SettingsTemplate.vue?vue&type=script&lang=js"

import "./SettingsTemplate.vue?vue&type=style&index=0&id=2a6d9ffc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6d9ffc"]])

export default __exports__